import React from 'react'
import '../../../stylesheets/Invoice.css'
import { TOKEN_STORAGE_KEY, getStorage, USER_STORAGE_KEY, getCurrentTeam } from "../../../dataHelpers/authenticationHelpers"
import { subscriptionHelpers } from '../../../dataHelpers';
import { Table, Media, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { User } from '../../../models'
import Loader from 'react-loader-spinner'
import LogoImage from '../../../images/sf-logo.png'
import AppError from "../../../models/AppError"
import RenewSubsModal from '../../ui/RenewSubsModal'
import { ErrorModal, SelectPaymentMethod } from './../../ui'
import { getTeam } from "../../../api"
import { SUCCESS, SUBS_PLAN_RENEWED, DATA_NOT_FOUND, NO_VALUE, SELECT_CHECKBOX } from '../../../constants'
import $ from 'jquery';

let date = new Date();
var currentYear = date.getFullYear();
let currTeamID = null
var teamId_array

class Invoice extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            subscriptionInvoiceDAta: [],
            loading: false,
            totlaPrice: 0,
            bulk_subsdata: [],
            errors: [],
            allControllerId: [],
            defaultPlanId: null,
            defaultPlanPrice: 0,
            discountValue: [],
            paymentByInvoice: false,
            teamName: [],
            isDealership: [],
            invoiceNumber: Math.floor(1000000000 + Math.random() * 9000000000),
            defaultCheck: true,
            allTotal: [],
            printIndexNumber: '',
            checkboxChecked: [],
            printRows: [],
            choosePaymentModal: false,
            paymentAmount: 0,
            isSupportUser: false,
            renewBySupport: false,
            modal: false,
            errorCheckbox : false
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.user = (props.user || JSON.parse(getStorage().getItem(USER_STORAGE_KEY)))
        this.handleRenewSubscriptionClick = this.handleRenewSubscriptionClick.bind(this)
        this.getDiscountDetails = this.getDiscountDetails.bind(this)
        this.paymentFromInvoice = this.paymentFromInvoice.bind(this)
        this.isDownloadDatFound = props.isDownloadDatFound
        this.toggle = this.toggle.bind(this)
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
        });
    }

    async componentDidMount() {
        currTeamID = getCurrentTeam()
        await this.getDiscountDetails(this.token, this.user.id)
        await this.getUserType()
        if (this.props.teamsId) {
            await this.getTeamNameBySupport(this.token, this.props.teamsId)
            await this.getInvoiceDetails(this.token, this.props.teamsId)
            await this.getSubscriptionPrice(this.token)
        } else {
            await this.getTeamNameByDealer(this.token, currTeamID)
            await this.getInvoiceDetails(this.token, currTeamID)
            await this.getSubscriptionPrice(this.token)
        }
    }

    getUserType() {
        let sessionData = User.fromLocalStorageString(getStorage().getItem(USER_STORAGE_KEY))
        let userType = sessionData.groups
        var supportUser = userType.indexOf("Support");

        if (supportUser !== -1) {
            this.setState({ isSupportUser: true })
        }
    }

    async paymentFromInvoice() {
        this.setState({ paymentByInvoice: true })
    }

    async getTeamNameByDealer(token, teamID) {
        try {
            let teamObj = await getTeam(token, teamID, 'pico')
            if (!teamObj.error) {
                this.state.teamName.push(teamObj.name)
                this.state.isDealership.push(teamObj.dealership)
            } else {
                console.log(teamObj.error)
            }
        } catch (error) {
            console.log(error)
        }
    }

    async getTeamNameBySupport(token, teamID) {
        try {
            teamId_array = teamID.split(',');
            for (var t = 0; t < teamId_array.length; t++) {
                let teamObj = await getTeam(token, teamId_array[t], 'pico')
                if (!teamObj.error) {
                    this.state.teamName.push(teamObj.name)
                    this.state.isDealership.push(teamObj.dealership)
                } else {
                    console.log(teamObj.error)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    async getInvoiceDetails(token, teamArr) {
        this.setState({ loading: true })
        try {
            let invoiceData = await subscriptionHelpers.getInvoiceData(token, teamArr)
            console.log("GOT INVOICE DATA")
            console.log(invoiceData)
            if (this.props.quoteControllersIds && this.props.selectOptionType && this.props.selectOptionType == "Invoice From Quote") {
                let arrValues = this.props.quoteControllersIds
                
                for(let i=0; i < invoiceData.length; i++ ){
                    for(let j=0; j < invoiceData[i].length; j++){
                        
                        if(!arrValues.includes(invoiceData[i][j]['controller']['id'])){
                            delete invoiceData[i][j];
                        }

                    }
                }
                
            }
            
            if (!invoiceData.error) {
                let totalSumList = [];
                invoiceData.map((e, i) => { totalSumList[i] = 0 })
                this.setState({
                    allTotal: totalSumList,
                    subscriptionInvoiceData: invoiceData,
                    loading: false,
                    paymentByInvoice: false
                })
                if (this.props.teamsId) {
                    this.isDownloadDatFound() // enable download button
                }
            } else {
                this.setState({ loading: false })
                //this.setState({ errors: [invoiceData.error],loading: false })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async getSubscriptionPrice(token) {
        try {
            let defaultSubsPlanData = await subscriptionHelpers.getDefaultSubsPlan(token)
            if (!defaultSubsPlanData.error) {
                (defaultSubsPlanData.length > 0 ? defaultSubsPlanData.map((d) => {
                    this.setState({ defaultPlanId: d.subscriptionPlan.id })
                    if ((d.subscriptionPlan.SubscriptionPlanPrice_set).length > 0) {
                        (d.subscriptionPlan.SubscriptionPlanPrice_set.map((p) =>
                            p.subscription_year == currentYear ?
                                this.setState({ defaultPlanPrice: p.subscription_price })
                                : null
                        )
                        )
                    }
                }
                ) : null)
            } else {
                this.setState({ errors: [defaultSubsPlanData.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    sumCheckboxVal(event, controllerId, isSeasonedVal, index, printindex) {
        const target = event.target;
        const isChecked = target.checked;
        let value = target.value
        var element = {}
        element.is_paid = true;
        element.is_trial = false;
        element.is_expired = false;
        element.controller = controllerId;
        if (!isSeasonedVal) {
            element.subscription_plan = this.state.defaultPlanId
        }
        let controllerIdObj = {}
        let totalSum = 0
        controllerIdObj.id = controllerId
        if (isChecked) {
            totalSum = this.state.allTotal[index] + parseFloat(value)
            this.state.allTotal.splice(index, 1, totalSum)
            this.state.bulk_subsdata.push(element)
            this.state.allControllerId.push(controllerIdObj)
            this.setState({ printIndexNumber: printindex })

            let checkedRow = this.state.printRows.filter(e => e !== printindex)
            this.setState({
                printRows: checkedRow
            })
            if(this.props.allControllerIdGet)
            {
                this.props.allControllerIdGet(this.state.allControllerId)
            }
            

        } else {
            let new_bulkdata = this.state.bulk_subsdata.filter(e => parseInt(e.controller) !== parseInt(controllerId))
            let new_controllerid = this.state.allControllerId.filter(function (e) { return e.id !== controllerId; });
            if(this.props.allControllerIdGet)
            {
            this.props.allControllerIdGet(new_controllerid)
            }

            totalSum = this.state.allTotal[index] - parseFloat(value)
            this.state.allTotal.splice(index, 1, totalSum)

            this.setState((ps) => ({
                bulk_subsdata: new_bulkdata,
                allControllerId: new_controllerid,
                printIndexNumber: printindex
            }));
            

            if (this.state.printRows.indexOf(printindex) === -1) {
                this.state.printRows.push(printindex)
            } else {
                let unCheckedRow = this.state.printRows.filter(e => e === printindex)
                this.setState({ printRows: unCheckedRow })
            }

        }
        

        if (this.state.checkboxChecked[index]) {
            this.state.checkboxChecked.splice(index, 1, false)
            document.getElementById('selectallCheck' + index).checked = false;
        }
        this.forceUpdate();
    }

    checkAllCheckbox(event, index) {
        const target = event.target;
        const allCheckboxChecked = target.checked
        var checkboxes = document.getElementsByName('subscription' + index + '[]')
        var checkboxesId = document.getElementsByName('subscriptionid' + index + '[]')
        var checkedSum = 0, unCheckedSum = 0
        if (allCheckboxChecked) {
            for (var i in checkboxes) {
                if (checkboxes[i].checked == false) {
                    checkboxes[i].checked = true;
                    checkedSum = checkedSum + parseFloat(checkboxes[i].value)
                } else {
                    if (checkboxes[i].value) {
                        unCheckedSum = unCheckedSum + parseFloat(checkboxes[i].value)
                    }
                }
            }
            this.state.allTotal.splice(index, 1, (checkedSum + unCheckedSum))

            for (var j in checkboxesId) {
                if (checkboxesId[j].value) {
                    var idArray = checkboxesId[j].value.split(',');
                    let selectChkId = idArray[0]
                    let selectSeason = idArray[1]

                    let objId = this.state.allControllerId.find(function (obj) { return obj.id === parseInt(selectChkId); })
                    if (objId === undefined) {
                        this.state.allControllerId.push({
                            id: parseInt(selectChkId)
                        });
                        if (selectSeason == 'false') {   // check plan is trial
                            this.state.bulk_subsdata.push({
                                is_paid: true,
                                is_trial: false,
                                is_expired: false,
                                is_renewed: true,
                                controller: parseInt(selectChkId),
                                subscription_plan: this.state.defaultPlanId
                            });
                        } else {
                            this.state.bulk_subsdata.push({
                                is_paid: true,
                                is_trial: false,
                                is_expired: false,
                                is_renewed: true,
                                controller: parseInt(selectChkId)
                            });
                        }
                    }
                }
            }

            if (this.state.checkboxChecked.length > 0) {
                this.state.checkboxChecked.splice(index, 1, true)
            } else {
                this.state.checkboxChecked.push(true)
            }

            let newPrintRows = []
            for (i of this.state.printRows) {
                if (i[0] != index) {
                    newPrintRows.push(i)
                }
            }

            this.setState({
                printRows: newPrintRows
            });
        } else {
            for (var k in checkboxes) {
                if (checkboxes[k].checked == true) {
                    checkboxes[k].checked = false;
                    checkboxes[k].disabled = false;
                }
                this.state.printRows.push(index + 'tr' + k)
            }
            this.state.allTotal.splice(index, 1, 0)

            this.setState({
                allControllerId: [],
                bulk_subsdata: [],
            });
            this.state.checkboxChecked.splice(index, 1, false)
        }
        if(this.props.allControllerIdGet)
            {
            this.props.allControllerIdGet(this.state.allControllerId)
            }
    }

    async handleRenewSubscriptionClick(e = null) {
        this.setState({
            loading: true,
            choosePaymentModal: false
        })
        try {
            let bulk_renewResponse = await subscriptionHelpers.renewBulkSubsPlan(this.token, this.state.bulk_subsdata)
            if (!bulk_renewResponse.error) {
                let appError = new AppError(SUCCESS, SUBS_PLAN_RENEWED)
                await this.setState({ errors: [appError], loading: false, modal: false })
                return
            } else {
                this.setState({ errors: [bulk_renewResponse.error] })
            }
        } catch (error) {
            let appError = new AppError("Failed to send request", error.message)
            this.setState({ errors: [appError] })
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({
            errors: errors,
        })
        if(this.state.errorCheckbox){
            this.setState({errorCheckbox:!this.state.errorCheckbox})
        } else {
            if (this.props.teamsId) {
                this.getInvoiceDetails(this.token, this.props.teamsId)
            } else {
                currTeamID = getCurrentTeam()
                this.getInvoiceDetails(this.token, currTeamID)
            }
        }    
    }

    async getDiscountDetails(token, dealerId) {
        this.setState({ loading: true })
        try {
            let discountData = await subscriptionHelpers.getAllAssignedDiscountList(token)
            if (!discountData.error) {
                this.setState({ discountValue: discountData })
            } else {
                this.setState({ errors: [discountData.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    componentDidUpdate() {
        let {subscriptionInvoiceData, defaultCheck} = this.state
        if (subscriptionInvoiceData && defaultCheck) {
            let checkboxLength = subscriptionInvoiceData.length
            if (checkboxLength > 0) {
                setTimeout(function () {
                    for (var chk = 0; chk < checkboxLength; chk++) {
                        var checkboxes = document.getElementsByName('subscription' + chk + '[]')
                        if (checkboxes.length > 0) {                        
                            document.getElementById('selectallCheck' + chk).click()
                        }
                    }
                }, 1500);                
                this.setState({ defaultCheck: false })
            }
        }
    }
    
    selectPayment = (amount, isSupport) => {
        var counter = 0;
        var anyCheckedItem = false
        $('.invoice-top').each(function () {
            var checkboxesId = document.getElementsByName('subscriptionid' + counter + '[]')
            var checkboxes = document.getElementsByName('subscription' + counter + '[]')
            for (var j in checkboxesId) {
                if (checkboxesId[j].value && checkboxes[j].checked == true) {
                    anyCheckedItem = true
                }
            }
            counter++;
        })
        if(amount <= 0.00 && anyCheckedItem === false) {
            console.log("NO AMOUNT")
            let appError = new AppError(NO_VALUE, SELECT_CHECKBOX)
            this.setState({ errors: [appError], errorCheckbox: !this.state.errorCheckbox })
        } else {
            this.setState({
                choosePaymentModal: !this.state.choosePaymentModal,
                paymentAmount: amount,
                renewBySupport: isSupport,
                modal: !this.state.modal
            })
        }        
    }

    printInvoice = (amount) => {
        if(amount <= 0.00) {            
            let appError = new AppError(NO_VALUE, SELECT_CHECKBOX)
            this.setState({ errors: [appError], errorCheckbox: !this.state.errorCheckbox })
        } else {
            window.print()
        }        
    }

    closeErrorCheckbox = () => {
        this.setState({ errorCheckbox: !this.state.errorCheckbox })      
    }

    render() {
        let { subscriptionInvoiceData, loading, checkboxChecked, printRows, errors, defaultPlanPrice,
            discountValue, paymentByInvoice, teamName, isDealership, invoiceNumber, allTotal, isSupportUser } = this.state
        let subsPrice = 0
        let planIsSeasoned = false
        let discountPercent = 0
        let discountPrice = 0
        let day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
        let month = ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
        let currDate = month + '-' + day + '-' + currentYear
        let generateType = "Invoice"
        if(this.props.selectOptionType && this.props.selectOptionType == "Quote"){
            generateType = "Quote"
        }

        return (<div className={paymentByInvoice ? "row justify-content-center align-items-center noprint" : "row justify-content-center align-items-center"}>
            {loading ? <div className="m-5 col-12 align-content-center text-center justify-content-center"><Loader type="TailSpin" width={60} height={60} /></div> :
                <div className="container">
                    {subscriptionInvoiceData && subscriptionInvoiceData.length > 0 ?
                        subscriptionInvoiceData.map((data, index) =>
                            <div className="col-md-9 invoice-top" id={"pdfcount" + index} key={'key' + index}>
                                <div className="row mar-t20">
                                    <div className="col-md-2">
                                        <Media object src={LogoImage} width="100" height="100" className="img-responsive invoice-img" />
                                    </div>
                                    
                                    <div className="col-md-3 invoice-text">
                                    {generateType == "Quote" ? <span>Team</span> :
                                        <span>Billed To</span>
                                    }
                                        <p>{teamName[index]}</p>
                                        <p>Date : {currDate}</p>
                                    </div>
                                
                                    <div className="col-md-3 invoice-text">
                                        <span>{generateType} Number</span>
                                        <p>{this.props.invoiceNumber ? this.props.invoiceNumber[index] : invoiceNumber}</p>
                                    </div>
                                    <div className="col-md-4 invoice-text">
                                        <span style={{ textAlign: "right" }}>{generateType} Total</span>
                                        <p className="invoice-red">
                                            $ {Math.abs(allTotal[index]).toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <hr style={{ borderTop: "3px solid #fa3b58" }} />
                                </div>

                                <div className="row table-responsive">
                                    {(isDealership[index] === true) ?
                                        <Table className="table-invoice">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '5%' }}>
                                                        <div className="form-check form-checkbox">
                                                            <input type="checkbox" onChange={(e) => this.checkAllCheckbox(e, index)} className="noprint form-check-input" id={"selectallCheck" + index} />
                                                        </div>
                                                    </th>
                                                    <th style={{ width: '12%' }}>Controller</th>
                                                    <th style={{ width: '21%' }}>Subscription Plan</th>
                                                    <th style={{ width: '10%' }}>Team</th>
                                                    <th style={{ width: '22%' }}>Subscription Price</th>
                                                    <th style={{ width: '10%' }}>Discount</th>
                                                    <th style={{ width: '20%' }}>Discounted Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.length > 0 ? (data.map((c, printindex) => {
                                                        //added
                                                        subsPrice = defaultPlanPrice
                                                        planIsSeasoned = true
                                                        if (c.subscription_plan && c.subscription_plan.SubscriptionPlanPrice_set.length > 0) {
                                                            (c.subscription_plan.SubscriptionPlanPrice_set.map((p) =>
                                                                p.subscription_year >= currentYear ?
                                                                    subsPrice = p.subscription_price
                                                                    : planIsSeasoned = false
                                                            )
                                                            )
                                                        } //else {
                                                            //subsPrice = defaultPlanPrice
                                                        //}

                                                        discountValue.map((d) =>
                                                            //d.team.id == c.team.id ?
                                                            (this.props.teamsId) ?
                                                                (d.team.id == teamId_array[index] ?
                                                                    discountPercent = d.discount.discount
                                                                    : null)
                                                                :
                                                                (d.team.id == currTeamID ?
                                                                    discountPercent = d.discount.discount
                                                                    : null)
                                                        )

                                                        discountPrice = (parseFloat(/*defaultPlanPrice*/ subsPrice) - (/*defaultPlanPrice*/ subsPrice * discountPercent) / 100)
                                                        return <tr
                                                            key={c.controller.serial_number + 'key'}
                                                            className={checkboxChecked[index] ? "" : (((printRows.indexOf(index + 'tr' + printindex) !== -1)) ? "noprint" : "")}
                                                            hidden={planIsSeasoned && !c.is_trial? true: false}
                                                        >
                                                            <td>
                                                                {!planIsSeasoned  || c.is_trial?
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        name={"subscription" + [index] + "[]"}
                                                                        //value={subsPrice}
                                                                        value={discountPrice}
                                                                        onChange={(e) => this.sumCheckboxVal(e, c.controller.id, planIsSeasoned, index, index + 'tr' + printindex)}
                                                                        className={checkboxChecked[index] ? "form-check-input noprint" : (((printRows.indexOf(index + 'tr' + printindex) === -1)) ? "form-check-input noprint" : "form-check-input")}
                                                                        id="exampleCheck1"
                                                                    />
                                                                    <input type="hidden" value={c.controller.id + ',' + planIsSeasoned} name={"subscriptionid" + [index] + "[]"} readOnly />
                                                                </div>:
                                                                null}

                                                            </td>
                                                            <td>
                                                                <p>{c.controller.serial_number}</p>
                                                            </td>
                                                            <td>{c.subscription_plan ? c.subscription_plan.name : null}</td>
                                                            <td>{c.controller.team ? c.controller.team.name : ''}</td>
                                                            <td>$ {/*defaultPlanPrice*/ subsPrice}</td>
                                                            <td>{discountPercent + ' %'}</td>
                                                            <td>{'$ ' + discountPrice.toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    })) : (<tr><td colSpan='7'>{DATA_NOT_FOUND}</td></tr>)
                                                }
                                                <tr>
                                                    <td colSpan="5">
                                                    </td>
                                                    <th>Total : </th>
                                                    <td>$ {Math.abs(allTotal[index]).toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        :
                                        <Table className="table-invoice">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div className="form-check form-checkbox">
                                                            <input type="checkbox" onChange={(e) => this.checkAllCheckbox(e, index)} className="noprint form-check-input" id={"selectallCheck" + index} />
                                                        </div>
                                                    </th>
                                                    <th>Controller</th>
                                                    <th>Subscription Plan</th>
                                                    <th>Team</th>
                                                    <th>Subscription Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.length > 0 ? (data.map((c, printindex) => {
                                                        subsPrice = defaultPlanPrice
                                                        planIsSeasoned = true
                                                        if (c.subscription_plan.SubscriptionPlanPrice_set.length > 0) {
                                                            (c.subscription_plan.SubscriptionPlanPrice_set.map((p) =>
                                                                p.subscription_year >= currentYear?
                                                                    subsPrice = p.subscription_price
                                                                    : planIsSeasoned = false
                                                            )
                                                            )
                                                        } //else {
                                                          //  subsPrice = defaultPlanPrice
                                                        //}
                                                        return <tr
                                                            key={c.controller.serial_number + 'key'}
                                                            className={checkboxChecked[index] ? "" : (((printRows.indexOf(index + 'tr' + printindex) !== -1)) ? "noprint" : "")}
                                                            hidden={planIsSeasoned && !c.is_trial? true: false}
                                                        >
                                                            <td>
                                                            {!planIsSeasoned || c.is_trial?
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        name={"subscription" + [index] + "[]"}
                                                                        value={subsPrice}
                                                                        //value={discountPrice}
                                                                        onChange={(e) => this.sumCheckboxVal(e, c.controller.id, planIsSeasoned, index, index + 'tr' + printindex)}
                                                                        className={checkboxChecked[index] ? "form-check-input noprint" : (((printRows.indexOf(index + 'tr' + printindex) === -1)) ? "form-check-input noprint" : "form-check-input")}
                                                                        id="exampleCheck1"
                                                                    />
                                                                    <input type="hidden" value={c.controller.id + ',' + planIsSeasoned} name={"subscriptionid" + [index] + "[]"} readOnly />
                                                                </div>:
                                                                null
                                                            }
                                                            </td>
                                                            <td>
                                                                <p>{c.controller.serial_number}</p>
                                                            </td>
                                                            <td>{c.subscription_plan ? c.subscription_plan.name : null}</td>
                                                            <td>{c.team.name}</td>
                                                            <td>$ {subsPrice}</td>
                                                        </tr>
                                                    })) : (<tr><td colSpan='5'>{DATA_NOT_FOUND}</td></tr>)
                                                }
                                                <tr>
                                                    <td colSpan="3">
                                                    </td>
                                                    <th>Total : </th>
                                                    <td>$ {Math.abs(allTotal[index]).toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    }
                                    <div className="pay_print_btn noprint" id={"print_pay_btn" + (index)}>  
                                    {generateType == "Quote" ? null : data.length > 0  ?
                                        (isSupportUser ?
                                            <Button className="noprint pay-button" onClick={() => { this.selectPayment(Math.abs(allTotal[index]).toFixed(2), true) }} color="primary">Pay</Button>
                                            :
                                            <Button className="noprint pay-button" onClick={() => { this.selectPayment(Math.abs(allTotal[index]).toFixed(2), false) }} color="primary">Pay</Button>):''
                                    }   
                                    {data.length > 0  ?
                                        ((!this.props.teamsId) &&
                                            <Button className="noprint print-left" color="primary" onClick={() => {this.printInvoice(Math.abs(allTotal[index]).toFixed(2)) }}>Print</Button>)
                                            :''
                                    }
                                    </div>
                                </div>

                            </div>) : DATA_NOT_FOUND
                    }
                    {(errors.map((appError, idx) =>
                        <ErrorModal key={idx} modal={true} toggle={() => (this.dismissError(appError))} text={appError.text} title={appError.title} />
                    ))}
                    
                    {this.state.renewBySupport ?
                        <RenewSubsModal controllerid={this.state.allControllerId} renewSubscriptionPlan={this.handleRenewSubscriptionClick} modal={this.state.modal} toggle={this.toggle} />
                        :
                        <SelectPaymentMethod isOpen={this.state.choosePaymentModal} backdrop='static' toggle={this.selectPayment} className={this.props.className}
                            invoicePayment={this.paymentFromInvoice} invoice="yes" controllerid={this.state.allControllerId}
                            amount={this.state.paymentAmount} renewSubscriptionPlan={this.handleRenewSubscriptionClick} />                        
                    }                   
                </div>
            }
        </div>)
    }
}

export default Invoice



// WEBPACK FOOTER //
// ./src/components/pages/subscription/Invoice.js